import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LoincObject, LoincService } from '../../../../../shared/services/loinc.service';
import { PageEvent } from '@angular/material/paginator';
import { KeyValue } from '@angular/common';

interface LoadingState {
  searching: boolean;
  sorting: boolean;
  paginating: boolean;
}

@Component({
  selector: 'app-loinc-list-display',
  templateUrl: './loinc-list-display.component.html',
  styleUrls: ['./loinc-list-display.component.scss']
})
export class LoincListDisplayComponent implements OnInit {
  results: LoincObject[] = [];
  query = new FormControl('', {nonNullable: true});
  language: string
  pageIndex = 0;
  itemsPerPage = 25;
  totalPages = 100;
  ordering = new FormControl('', {nonNullable: true});
  reverse = new FormControl(false);
  loadingState: LoadingState = {
    searching: false,
    sorting: false,
    paginating: false,
  };

  @Input() loincService!: LoincService;
  @Input() primaryKey: string = 'id';

  constructor(
      public translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.language = localStorage.getItem('lang') ?? 'vi';
    this.ordering.setValue(this.primaryKey);
    this.search();
  }

  emptySearchBox(): void {
    this.query.setValue('');
  }

  getOrdering(): string {
    if (this.reverse.value) {
      return '-' + this.ordering.value;
    }
    return this.ordering.value;
  }

  search(): void {
    this.loadingState.searching = true;
    this.loincService.list(this.query.value, this.itemsPerPage, 1, this.getOrdering()).subscribe((data) => {
      this.results = data.results;
      this.totalPages = data.count;
      this.loadingState.searching = false;
      this.pageIndex = 0;
    })
  }

  paginate(event: PageEvent) {
    this.loadingState.paginating = true;
    this.loincService.list(this.query.value, event.pageSize, event.pageIndex + 1, this.getOrdering()).subscribe((data) => {
      this.results = data.results;
      this.totalPages = data.count;
      this.pageIndex = event.pageIndex;
      this.loadingState.paginating = false;
    })
  }

  sort() {
    this.loadingState.sorting = true;
    this.loincService.list(this.query.value, this.itemsPerPage, 1, this.getOrdering()).subscribe((data) => {
      this.results = data.results;
      this.totalPages = data.count;
      this.pageIndex = 0;
      this.loadingState.sorting = false;
    })
  }

  get_keys(): {[key: string]: string} {
    if (this.results.length == 0) return {};

    let keys: {[key: string]: string} = {};
    Object.entries(this.results[0]).forEach(
      ([key, value]) => {
        if (key !== 'id' || this.primaryKey === 'id') {
          keys[key] = value.verbose_name;
        }
      }
    )
    return keys;
  }

  isResultEmpty(): boolean {
    return this.results.length == 0;
  }

  originalOrder = (a: KeyValue<any,any>, b: KeyValue<any,any>): number => {
    return 0;
  }
}
